import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ContactContainer, ContactHeader, ContactContent, ContactLeft, ContactRight, ContactParagraph } from "./ContactComponents";
import HCaptcha from '@hcaptcha/react-hcaptcha';

function Contact() {
  const { t } = useTranslation();
  const [result, setResult] = useState("");
  const [formDataState, setFormDataState] = useState(null);
  const hcaptchaRef = useRef(null);

  const onSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    setFormDataState(formData);
    setResult(t('contact.verifying'));
    hcaptchaRef.current.execute();
  };

  const onHCaptchaVerify = async (token) => {
    if (!formDataState) return;

    formDataState.append("access_key", "9129d045-33e7-4fa0-bbfa-f4f8fd722ef3");
    formDataState.append("h-captcha-response", token);

    setResult(t('contact.sending'));

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formDataState
    });

    const data = await response.json();

    if (data.success) {
      setResult(t('contact.sent'));
    } else {
      console.log("Error", data);
      setResult(data.message || t('contact.error'));
    }

    setFormDataState(null);
    hcaptchaRef.current.resetCaptcha();
  };

  return (
    <ContactContainer>
      <ContactContent>
        <ContactLeft>
          <ContactHeader id="contactSection">{t('contact.heading')}</ContactHeader>
          <ContactParagraph>
            {t('contact.text')}
          </ContactParagraph>
        </ContactLeft>

        <ContactRight>
          <form onSubmit={onSubmit}>
            <input type="text" name="name" placeholder={t('contact.name')} required />
            <input type="email" name="email" placeholder={t('contact.email')} required />
            <input type="text" name="subject" placeholder={t('contact.subject')} required />
            <textarea name="message" placeholder={t('contact.message')} required></textarea>
            <button type="submit">{t('contact.submit')}</button>
          </form>

          <HCaptcha
            sitekey="50b2fe65-b00b-4b9e-ad62-3ba471098be2"
            onVerify={onHCaptchaVerify}
            reCaptchaCompat={false}
            ref={hcaptchaRef}
            size="invisible"
          />

          <h5 style={{ color: 'white' }}>{result}</h5>
        </ContactRight>
      </ContactContent>
    </ContactContainer>
  );
}

export default Contact;